import type { QuestionnaireTemplateInfoDto } from "@/models/dto/questionnaireTemplateInfoDto";
import type { QuestionnaireLanguage } from "@/models/enum/questionnaireLanguage";
import type { QuestionnaireTemplate } from "@/models/questionnaireTemplate";
import axios from "axios";

export const getTemplate = async (
  templateId: string,
  language: QuestionnaireLanguage
): Promise<QuestionnaireTemplate> => {
  const resp = await axios.get<QuestionnaireTemplate>(
    "api/questionnaire-template",
    { params: { templateId, language } }
  );
  return resp.data;
};

export const getTemplates = async (): Promise<
  QuestionnaireTemplateInfoDto[]
> => {
  const resp = await axios.get<QuestionnaireTemplateInfoDto[]>(
    "/api/questionnaire-template/available"
  );
  return resp.data;
};
